export default "__VITE_ASSET__CSclSllK__"